export default __webpack_public_path__ + "static/media/Blooded Boots of Passing Spirits.bcc5caf2.jpg";